export const ERROR_PAGES = {
  NotFound: {
    en: {
      title: 'Whoops, that page cannot be found.',
      description:
        'The page you were looking for can’t be found or doesn’t exist.',
      errorCode: 'Error code: 404',
    },
    de: {
      title: 'Hoppla, diese Seite konnte nicht gefunden werden.',
      description:
        'Die Seite, nach der du gesucht hast, konnte nicht gefunden werden oder existiert nicht.',
      errorCode: 'Fehlercode: 404',
    },
    fr: {
      title: 'Oups, cette page est introuvable.',
      description:
        'La page que vous cherchez n’a pas pu être trouvée ou n’existe pas.',
      errorCode: 'Code erreur : 404',
    },
    es: {
      title: '¡Huy! No se puede encontrar la página.',
      description: 'La página que buscas no se puede encontrar o no existe.',
      errorCode: 'Código de error: 404',
    },
    it: {
      title: 'Ops, impossibile trovare la pagina.',
      description:
        'La pagina che stai cercando non è stata trovata o non esiste.',
      errorCode: 'Codice d’errore: 404',
    },
  },
  ServerError: {
    en: {
      title: 'Well, that was unexpected.',
      description:
        'This page is currently unavailable. Our development team has been notified to resolve this issue as soon as possible.',
      errorCode: 'Error code: 5xx',
    },
    de: {
      title: 'Hm, das ist ungewöhnlich.',
      description:
        'Diese Seite ist derzeit nicht verfügbar. Unser Entwicklungsteam wurde informiert und wird dieses Problem so schnell wie möglich beheben.',
      errorCode: 'Fehlercode: 5xx',
    },
    fr: {
      title: 'Quelque chose d’inattendu s’est produit.',
      description:
        'Cette page est actuellement indisponible. Nous avons été notifiés et allons nous en occuper au plus vite.',
      errorCode: 'Code erreur : 5xx',
    },
    es: {
      title: 'Bueno, eso fue inesperado.',
      description:
        'Está página está temporalmente fuera de servicio. Nuestro equipo de desarrollo ha sido notificado para resolver este asunto tan pronto como sea posible.',
      errorCode: 'Código de error: 5xx',
    },
    it: {
      title: 'Questo non era previsto.',
      description:
        'La pagina non è attualmente disponibile. Il nostro team di sviluppo è stato informato e si occuperà del problema al più presto.',
      errorCode: 'Codice d’errore: 5xx',
    },
  },
  CTA: {
    en: 'Go to homepage',
    de: 'Geh zurück zur Homepag',
    fr: 'Aller à la page d’accueil',
    es: 'Ir al inicio',
    it: 'Vai alla pagina principale',
  },
}
